module.exports = __webpack_public_path__ + "img/circle-full.793b3071.svg";